import {createContext, useContext, useReducer} from "react";

const QuizStateContext = createContext(undefined);
const QuizDispatchContext = createContext(undefined);

export const NAVIGATED_FORWARD = 'navigatedForward'
export const NAVIGATED_BACKWARD = 'navigatedBackward'
export const NAVIGATED_TO_INDEX = 'navigatedToIndex'
export const ANSWER_SELECTED = 'answerSelected'
export const ANSWER_REVEALED = 'answerRevealed'
export const QUIZ_RESET = 'quizReset'
export const QUIZ_STARTED = 'quizStarted'
export const QUIZ_FINISHED = 'quizFinished'
export const STARTINDEX_CHANGED = 'startIndexChanged'


const initialState = {
    quiz: {},
    immediateFeedback: false,
    questionIndex: 0,
    view: "landing",
    onSuccess: null,
    onClose: null
}

const quizReducer = (state, action) => {
    console.debug({action})
    switch (action.type) {
        case QUIZ_STARTED:
            return {
                ...state,
                view: "quiz"
            }
        case QUIZ_FINISHED:
            return {
                ...state,
                view: "result"
            }
        case NAVIGATED_FORWARD:
            return {
                ...state,
                questionIndex: state.questionIndex + 1
            }
        case NAVIGATED_BACKWARD:
            return {
                ...state,
                questionIndex: state.questionIndex - 1
            }
        case NAVIGATED_TO_INDEX:
            return {
                ...state,
                questionIndex: action.questionIndex
            }
        case ANSWER_SELECTED: {
            const currentQ = state.quiz?.questions?.find(question => question.uniqueId === action.questionUniqueId);
            if (currentQ?.answerRevealed) {
                return state;
            }
            return {
                ...state,
                quiz: {
                    ...state.quiz,
                    questions: (state.quiz?.questions || []).map(question =>
                        question.uniqueId === action.questionUniqueId
                            ? { ...question, selectedAnswerUniqueId: action.selectedAnswerUniqueId }
                            : question
                    )
                },
            };
        }
        case ANSWER_REVEALED:
            return {
                ...state,
                quiz: {
                    ...state.quiz,
                    questions: (state.quiz?.questions || []).map(question =>
                        question.uniqueId === action.questionUniqueId
                            ? { ...question, answerRevealed: true }
                            : question
                    )
                }
            };
        case QUIZ_RESET:
            return {
                ...state,
                quiz: {
                    ...state.quiz,
                    questions: (state.quiz?.questions || []).map(question => ({
                        ...question,
                        selectedAnswerUniqueId: undefined,
                        answerRevealed: false
                    })),
                },
                questionIndex: 0,
                view: "landing"
            }
        case STARTINDEX_CHANGED:
            return {
                ...state,
                questionIndex: action.startIndex,
                view: "quiz"
            }
        default:
            throw new Error(`Unhandled action type ${action.type}`);

    }
}

export const QuizProvider = ({quiz, onSuccess, onClose, children}) => {
    const isSpectrum = quiz?.type === "spectrum";
    const immediateFeedback = isSpectrum ? false : Boolean(quiz?.immediateFeedback);
    const normalizedQuiz = quiz ? {
        ...quiz,
        immediateFeedback: immediateFeedback,
        questions: (quiz.questions || []).map(q => ({
            ...q,
            answerRevealed: false
        }))
    } : {};

    const [state, dispatch] = useReducer(
        quizReducer,
        {
            ...initialState,
            immediateFeedback: immediateFeedback,
            quiz: normalizedQuiz,
            onSuccess: onSuccess,
            onClose: onClose
        },
        undefined
    )

    return (
        <QuizStateContext.Provider value={state}>
            <QuizDispatchContext.Provider value={dispatch}>
                {children}
            </QuizDispatchContext.Provider>
        </QuizStateContext.Provider>
    )
}

export const useQuizState = () => {
    const context = useContext(QuizStateContext)
    if (undefined === context) {
        throw new Error("useQuizState must be used within a QuizProvider")
    } else {
        return context
    }
}

export const useQuizDispatch = () => {
    const context = useContext(QuizDispatchContext)
    if (undefined === context) {
        throw new Error("useQuizDispatch must be used within a QuizProvider")
    } else {
        return context
    }
}